var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFileCode(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.16732 15.4167C3.16732 15.8037 3.16732 15.9972 3.18871 16.1596C3.3364 17.2815 4.21917 18.1642 5.341 18.3119C5.50346 18.3333 5.69697 18.3333 6.08398 18.3333H12.5007C13.9008 18.3333 14.6008 18.3333 15.1356 18.0608C15.606 17.8212 15.9885 17.4387 16.2282 16.9683C16.5007 16.4335 16.5007 15.7335 16.5007 14.3333V8.32351C16.5007 7.71203 16.5007 7.4063 16.4316 7.11858C16.3703 6.86349 16.2693 6.61963 16.1323 6.39594C15.9776 6.14365 15.7615 5.92746 15.3291 5.49508L12.6722 2.83823C12.2398 2.40585 12.0237 2.18966 11.7714 2.03506C11.5477 1.89798 11.3038 1.79697 11.0487 1.73573C10.761 1.66666 10.4553 1.66666 9.8438 1.66666H6.08398C5.69697 1.66666 5.50346 1.66666 5.341 1.68804C4.21917 1.83574 3.3364 2.71851 3.18871 3.84034C3.16732 4.0028 3.16732 4.19631 3.16732 4.58332M6.50065 12.0833L8.58398 9.99999L6.50065 7.91666M3.16732 7.91666L1.08398 9.99999L3.16732 12.0833",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileCode);
export default __webpack_public_path__ + "static/media/file-code.cc0d653b.svg";
export { ForwardRef as ReactComponent };